export const cardContentStyles = { paddingTop: '10px', paddingLeft: { xs: '16px', md: '24px' }, paddingRight: { xs: '16px', md: '24px' } };
export const tableRowStyles = { '&:last-child td, &:last-child th': { border: 0 } };
export const loadMoreBoxStyles = { textAlign: "center", marginTop: "30px", marginBottom: "35px" };
export const loadMoreDescStyles = { marginTop: "24px" };